export const aNamed = "a-named";



// WEBPACK FOOTER //
// ./src/mod2.js